<template>
  <div class="map-mode-container">
    <van-nav-bar
      :border="false"
      :title="companyData.name"
      @click-left="$router.back()"
    >
      <template #left>
        <van-icon name="close" color="#fff" size="20" />
      </template>
    </van-nav-bar>
    <div ref="map" class="map-box" />
    <div class="field-statistics">
      <div>
        已绘制轮廓地块:<span class="have">{{ haveDraw.have }}</span>
      </div>
      <div style="text-align: right;">
        未绘制轮廓地块:<span class="no">{{ haveDraw.no }}</span>
      </div>
    </div>
    <van-tabs
      v-show="tabVisible"
      v-model="tabActive"
      background="rgba(65,193,158,.8)"
      color="#fff"
      title-active-color="#fff"
      title-inactive-color="#fff"
      class="tabs-box"
    >
      <van-tab title="品种">
        <div class="tab-list">
          <template v-for="i in farmList">
            <div v-for="(j,index) in i.cropList" :key="''+i.id+index" class="crop-item" @click="toField(i)">
              <van-image :src="j.cropPic" width="32" height="32" />
              <span>{{ j.cropBreed }}</span>
            </div>
          </template>
        </div>
      </van-tab>
      <van-tab title="地块">
        <div class="tab-list">
          <div v-for="i in farmList" :key="i.id" class="field-item" @click="toField(i)">
            <svg-icon icon-class="field" />
            <span>{{ i.landName }}</span>
          </div>
        </div>
      </van-tab>
    </van-tabs>
    <div v-show="!tabVisible" class="field-detail">
      <van-nav-bar
        :border="false"
        :title="fieldData.name"
        @click-left="tabVisible=!tabVisible"
        @click-right="$router.push({name: 'PlotDetail', query: {landId: fieldData.id}})"
      >
        <template #left>
          <van-icon name="close" color="#fff" size="20" />
        </template>
        <template #title>
          <div class="name">
            {{ fieldData.landName }}
          </div>
          <div class="area">
            {{ fieldData.landArea + fieldData.landAreaUnit }}
          </div>
        </template>
        <template #right>
          <div class="name">
            进入地块
          </div>
        </template>
      </van-nav-bar>
      <div class="list-box">
        <div class="tab-list">
          <div v-for="(j,index) in fieldData.cropList" :key="index" class="crop-item">
            <van-image :src="j.cropPic" width="32" height="32" />
            <span>{{ j.cropBreed }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as maptalks from 'maptalks'
import api from '@/api'
import { mapGetters } from 'vuex'
import { mapCenter } from '@/constant/common'
export default {
  name: 'MapMode',
  data() {
    return {
      loading: false,
      farmList: [],
      companyData: {},
      map: undefined,
      drawLayer: undefined,
      cropLayer: undefined,
      tabVisible: true,
      tabActive: '',
      fieldData: {}
    }
  },
  computed: {
    ...mapGetters(['userData']),
    haveDraw() {
      let have = 0
      let no = 0
      this.farmList.forEach(i => {
        if (i.latLng) {
          have++
        } else {
          no++
        }
      })
      return { have, no }
    }
  },
  created() {
    this.initData()
  },
  mounted() {
  },
  methods: {
    async initData() {
      this.loading = true
      await api.getCompany().then(({ data }) => {
        this.companyData = data
      })
      await api.getFarmlandList({ pageSize: 1000 }).then(({ data: { list }}) => {
        this.farmList = list
      })
      this.loading = false
      this.$nextTick(() => {
        this.initMap()
      })
    },
    initMap() {
      this.map = new maptalks.Map(this.$refs.map, {
        center: this.companyData.latLng ? this.companyData.latLng.split(',') : mapCenter,
        // pitch: 45,
        zoom: 17,
        // minZoom: 10,
        // maxZoom: 18,
        // 边界限定
        // maxExtent: new maptalks.Extent(107.1616482640876, 31.064838749208178, 108.64342926994686, 31.836872151475546),
        // 缩放控件
        zoomControl: this.editable ? { position: { left: '20', bottom: '60' }} : false,
        attribution: false,
        baseLayer: new maptalks.GroupTileLayer('GoogleBase', [
          new maptalks.TileLayer('satellite', {
            urlTemplate: 'https://map.whhda.xyz/gmap?x={x}&y={y}&z={z}',
            subdomains: ['0', '1', '2', '3']
            // zIndex: 2
          })
        ])
      })
      // 新增地块边界图层
      this.drawLayer = new maptalks.VectorLayer('drawLayer').addTo(this.map)
      this.cropLayer = new maptalks.VectorLayer('cropLayer').addTo(this.map)
      this.farmList.forEach(i => {
        if (i.latLng) {
          const geometry = maptalks.Geometry.fromJSON(JSON.parse(i.latLng)).setId(i.id)
          this.drawLayer.addGeometry(geometry)
          // 添加作物图标
          if (i.cropList.length) {
            const markerSize = 40
            const markerPosition = [
              { x: 0, y: 0 },
              { x: markerSize, y: 0 },
              { x: 0, y: markerSize },
              { x: markerSize, y: markerSize }
            ]
            new maptalks.Marker(geometry.getCenter(), {
              id: i.id,
              symbol: i.cropList.reduce((total, j, index) => {
                if (index < 4) {
                  total.push({
                    markerFile: j.cropPic,
                    'markerWidth': markerSize,
                    'markerHeight': markerSize,
                    'markerDx': markerPosition[index].x,
                    'markerDy': markerPosition[index].y
                  })
                }
                return total
              }, [])
            }).addTo(this.cropLayer)
          }
        }
      })
    },
    toField(val) {
      const geometry = this.drawLayer.getGeometryById(val.id)
      if (!geometry) {
        this.$toast('该地块未绘制轮廓')
      } else {
        this.map.fitExtent(geometry.getExtent(), -1)
      }
      this.fieldData = val
      this.tabVisible = false
    }
  }
}
</script>

<style lang="less" scoped>
.map-mode-container {
  position: relative;
  height: 100%;
  > .van-nav-bar {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, .2);
    ::v-deep {
      .van-nav-bar__title {
        color: #fff;
      }
    }
  }
}
.map-box {
  height: 100%;
}
.field-statistics {
  position: absolute;
  top: 60px;
  left: 20px;
  right: 20px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  color: #fff;
  font-size: 12px;
  padding: 6px 20px;
  border-radius: 16px;
  background: rgba(0,0,0,.46);
  span {
    font-size: 16px;
    font-weight: 600;
  }
  .have {
    color: @primary-color;
  }
  .no {
    color: #ff0;
  }
}
.tabs-box {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  .van-tab__pane {
    height: 200px;
    overflow-y: auto;
    background: rgba(65,193,158,.6);
  }
}
.tab-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, 110px);
  justify-content: space-between;
  grid-gap: 10px;
  overflow-y: auto;
  padding: 10px;
  font-size: 12px;
  .crop-item {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 8px;
    color: #fff;
    background-color: rgba(6,56,42,.6);
    border-radius: 4px;
    .van-image {
      margin-right: 4px;
    }
  }
  .field-item {
    display: flex;
    align-items: center;
    width: 100%;padding: 8px;
    color: #fff;
    background-color: rgba(6,56,42,.6);
    border-radius: 4px;
    .svg-icon {
      width: 32px;
      height: 32px;
      margin-right: 4px;
    }
    span {
      word-break: break-word;
    }
  }
}
.field-detail {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  .van-nav-bar {
    background: rgba(65,193,158,.8);
    .name,
    .area {
      color: #fff;
    }
    .area {
      font-size: 12px;
    }
  }
  .list-box {
    height: 200px;
    overflow-y: auto;
    background: rgba(65,193,158,.6);
  }
}
</style>
